import React, { useEffect, useState } from "react";
import {
    Typography,
    Container,
    Dialog,
    Grid,
    TextField,
    Select,
    FormControl,
    InputLabel,
    CircularProgress,
} from "@material-ui/core";
import { CommonStyles } from "../../commons/CommonStyles";
import { DialogStyles } from "../CommonComponents/Dialogs/DialogStyles";
import { UserVerificationsStyles } from "../UserVerifications/UserVerificationsStyles";
import { checkIsNullUndefined, getErrorMessage, getScreenWidth } from "../../commons/Utils";
import {
    PostAuthorizeAuthorize,
} from "../../services/ReasonService";
import {
    GetUtilitiesCorreosIdGetUrlRedirectOauth,
} from "../../services/UtilitiesCallsService";
import { useTranslation } from "react-i18next";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { setSessionItem } from "../../services/Commons";
import { sessionValues } from "../../commons/EnumsGeneral";
import {
    PostApplicationAuxUserPhone,
    PostApplicationAuxUserEmail,
    PostApplicationAuxEmail2FASend,
    PostApplicationAuxPhone2FASend,
    PostApplicationAuxVerificationTwoFactorAuthenticationPhone,
    PostApplicationAuxVerificationTwoFactorAuthenticationEmail,
} from "../../services/ApplicationAuxCallsService";
import { Constants } from "../../commons/Constants";
import ReCAPTCHA from "react-google-recaptcha";

export function Dialog2FASetPhoneLogin(props) {
    const { open, setOpen, auxiliarInfo, finishOperation, loginWithPhone } = props;
    const commonClasses = CommonStyles();
    const dialogClasses = DialogStyles();
    const classes = UserVerificationsStyles();
    const { t } = useTranslation();

    const [phoneList, setPhoneList] = useState([]);
    const [phone, setPhone] = useState("");
    const [emailList, setEmailList] = useState([]);
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);
    const [sended, setSended] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpError, setOtpError] = useState(false);
    const [otpErrorText, setOtpErrorText] = useState("");
    const [circularProgress, setCircularProgress] = useState(false);
    const [circularProgress0, setCircularProgress0] = useState(false);
    const [reCaptchaToken, setReCaptchaToken] = useState(null);
    const [progressBar, setProgressBar] = useState(false);

    useEffect(() => {
        if (open && !checkIsNullUndefined(auxiliarInfo.respo)) {
            setCircularProgress0(true);
            let searchParams = new URLSearchParams(auxiliarInfo.respo);
            let code = searchParams.get('code');
            let userName = auxiliarInfo.user;
            let auxCall = loginWithPhone ? PostApplicationAuxUserEmail : PostApplicationAuxUserPhone;
            let auxListSetter = loginWithPhone ? setEmailList : setPhoneList;
            let auxSetter = loginWithPhone ? setEmail : setPhone;
            auxCall(code, userName).then((response) => {
                if (response && !response.Status) {
                    auxListSetter(response);
                    let auxValue = checkIsNullUndefined(response[0]) ? "" : response[0];
                    auxSetter(auxValue);
                    setCircularProgress0(false);
                } else {
                    finishOperation("error", getErrorMessage(response, t));
                    setOpen(false);
                };

            });
        };
    }, [open, auxiliarInfo]);

    useEffect(() => {
        clearAll();
    }, [phone]);

    const clearAll = () => {
        setSended(false);
        setOtp("");
        setOtpError(false);
        setOtpErrorText("");
        setReCaptchaToken(null);
        setProgressBar(false);
    };

    const handleSend = () => {
        setSending(true);
        let auxError = { error: false, errorText: "" };
        let auxValue = loginWithPhone ? email : phone;
        let auxCall = loginWithPhone ? () => PostApplicationAuxEmail2FASend(auxValue) : () => PostApplicationAuxPhone2FASend(auxValue, reCaptchaToken);
        auxCall(auxValue).then((response) => {
            if (response && !response.Status) {
                setSended(true);
            } else {
                auxError.error = true;
                auxError.errorText = getErrorMessage(response, t);
                setSended(false);
            };
            setSending(false);
        });
    };

    const handleCancel = () => {
        clearAll();
        setPhone("");
        setPhoneList([]);
        setOpen(false);
    };

    const handleChangeData = (value) => {
        let auxSetter = loginWithPhone ? setEmail : setPhone;
        auxSetter(value);
    };

    const handleChangeOtp = (value) => {
        const re = /^[0-9\b]{1,12}$/;
        if (value === "" || re.test(value)) {
            setOtp(value);
        };
    };

    const handleVerificate = () => {
        setCircularProgress(true);
        let auxValue = loginWithPhone ? email : phone;
        let auxCall = loginWithPhone ? PostApplicationAuxVerificationTwoFactorAuthenticationEmail : PostApplicationAuxVerificationTwoFactorAuthenticationPhone;
        auxCall(auxValue, otp, auxiliarInfo.user).then((response) => {
            if (response && !response.Status) {
                setCircularProgress(false);
                auxiliarInfo.secondCheckAcm(auxiliarInfo.respo, auxiliarInfo.redUrl, auxiliarInfo.user);
                clearAll();
                setOpen(false);
            } else {
                setOtpError(true);
                setOtpErrorText(t("login2FASetPhoneError"));
            };
            setCircularProgress(false);
        });
    };

    const goToVerifications = () => {
        setCircularProgress(true);
        setSessionItem("2FA", true);
        let auxAppOid = process?.env?.REACT_APP_APP_OID;
        let auxAppCode = Constants.cidCode;
        let auxPersonType = 1;
        let auxAppName = t("correosId");
        setSessionItem(sessionValues.appOid, auxAppOid);
        setSessionItem(sessionValues.appCode, auxAppCode);
        setSessionItem(sessionValues.appPersonType, auxPersonType);
        setSessionItem(sessionValues.appName, auxAppName);
        GetUtilitiesCorreosIdGetUrlRedirectOauth(auxAppOid).then((response) => {
            if (response && !response.Status) {
                logIn(response[0]);
            } else {
                setCircularProgress(false);
                finishOperation("error", getErrorMessage(response, t));
            };
        });
    };

    const logIn = (redirectUrl) => {
        PostAuthorizeAuthorize(auxiliarInfo.user, auxiliarInfo.pass, redirectUrl, null, false).then((response) => {
            if (response && !response.Status) {
                auxiliarInfo.secondCheckAcm(response, redirectUrl, auxiliarInfo.user);
            } else {
                setCircularProgress(false);
                finishOperation("error", getErrorMessage(response, t));
            };
        });
    };

    const handleOnChangeReCaptcha = (value) => {
        setReCaptchaToken(value);
    };

    const mountForm = () => {
        let auxText = loginWithPhone ? "email" : "PersonaTelfMovil";
        let auxList = loginWithPhone ? emailList : phoneList;
        let auxValue = loginWithPhone ? email : phone;
        return (
            <Grid item xs={12} sm={9}>
                <FormControl variant="filled" fullWidth color="secondary" className={commonClasses.inputsStyle}>
                    <InputLabel label={t(auxText)} color="secondary">
                        {t(auxText)}
                    </InputLabel>
                    <Select
                        native
                        color="secondary"
                        value={auxValue}
                        onChange={(value) => handleChangeData(value.target.value)}
                        label={t(auxText)}
                    >
                        {auxList?.map((auxValue) => {
                            return (
                                <option key={auxValue} value={auxValue}>
                                    {auxValue}
                                </option>
                            );
                        })}
                    </Select>
                </FormControl>
            </Grid>
        );
    };

    const getSubText = () => {
        let auxText = loginWithPhone ? "email" : "PersonaTelfMovil";
        let subText = t("login2FASendText") + " " + t(auxText) + ".";
        return subText;
    };

    const checkDisabledSend = () => {
        return sending || (!loginWithPhone && checkIsNullUndefined(reCaptchaToken));
    }

    const checkDisabledConfirm = () => {
        return !sended || otpError || checkIsNullUndefined(otp) || progressBar || (!loginWithPhone && checkIsNullUndefined(reCaptchaToken));
    };

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={() => handleCancel()}
            PaperProps={{ classes: { root: dialogClasses.dialogWindow } }}
        >
            {circularProgress0 ? <CircularProgress className={commonClasses.circularProgress} /> :
                <>
                    {(loginWithPhone && emailList.length == 0) || (!loginWithPhone && phoneList.length == 0) ?
                        <>
                            <Container className={commonClasses.dialogTitle}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography
                                            variant="h4"
                                            className={commonClasses.dialogTitleText}
                                        >
                                            {t("login2FASetPhoneTitle")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Container>
                            <Container className={commonClasses.dialogContainer}>
                                <Grid container item xs={12} className={commonClasses.gridIdentity}>
                                    <Grid item xs={12} style={{ marginBottom: "1em" }}>
                                        <Typography className={commonClasses.dialogContentText}>
                                            {t("login2FASetPhoneText")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid
                                    item
                                    container
                                    xs={12}
                                    className={dialogClasses.dialogButtonContainer}
                                >
                                    <Grid item sm={6} xs={12}>
                                        <CorreosButton
                                            onClick={() => setOpen(false)}
                                            className={dialogClasses.dialogButtonLeft}
                                        >
                                            {t("cancel")}
                                        </CorreosButton>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <CorreosButton
                                            variant="contained"
                                            color="primary"
                                            onClick={goToVerifications}
                                            className={dialogClasses.dialogButtonRight}
                                            circularProgress={circularProgress}
                                        >
                                            {t("accept")}
                                        </CorreosButton>
                                    </Grid>
                                </Grid>
                            </Container>
                        </> : (
                            <>
                                <Container className={dialogClasses.dialogTitle}>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant="h4" className={dialogClasses.dialogTitleText}>
                                                {t("login2FASendPhoneTitle")}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Container>
                                <Container className={dialogClasses.dialogContainer}>
                                    <Grid container item xs={12} className={commonClasses.gridIdentity}>
                                        <Grid item xs={12} style={{ marginBottom: "1em" }}>
                                            <Typography className={commonClasses.dialogContentText}>
                                                {getSubText()}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} spacing={1}>
                                        {mountForm()}
                                        <Grid item xs={12} sm={3} className={classes.buttonAdd}>
                                            <CorreosButton
                                                color={sended ? "secondary" : "primary"}
                                                variant={sended ? "outlined" : "contained"}
                                                onClick={() => handleSend()}
                                                disabled={checkDisabledSend()}
                                                circularProgress={sending}
                                                fullWidth
                                            >
                                                {sended ? t("reSend") : t("send")}
                                            </CorreosButton>
                                        </Grid>
                                        {!loginWithPhone && (
                                            <Grid item xs={12}>
                                                <Grid style={{ display: 'grid' }}>
                                                    <ReCAPTCHA
                                                        sitekey={process?.env?.REACT_APP_RECAPTCHA_KEY}
                                                        onChange={handleOnChangeReCaptcha}
                                                        size={getScreenWidth() > 440 ? "normal" : "compact"}
                                                        style={{ margin: "auto" }} />
                                                </Grid>
                                            </Grid>
                                        )}
                                        {sended && (
                                            <Grid item xs={12}>
                                                <TextField
                                                    color="secondary"
                                                    defaultValue={otp}
                                                    value={otp}
                                                    onChange={(value) => handleChangeOtp(value.target.value)}
                                                    variant="filled"
                                                    fullWidth
                                                    name="otp"
                                                    autoFocus
                                                    label={t("login2FASetPhoneOtp")}
                                                    type="text"
                                                    error={otpError}
                                                    helperText={otpErrorText}
                                                    required
                                                    className={commonClasses.inputsStyle}
                                                />
                                            </Grid>
                                        )}
                                        <Grid
                                            item
                                            container
                                            xs={12}
                                            className={dialogClasses.dialogButtonContainer}
                                        >
                                            <Grid item sm={6} xs={12}>
                                                <CorreosButton
                                                    onClick={handleCancel}
                                                    className={dialogClasses.dialogButtonLeft}
                                                >
                                                    {t("cancel")}
                                                </CorreosButton>
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <CorreosButton
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleVerificate}
                                                    className={dialogClasses.dialogButtonRight}
                                                    disabled={checkDisabledConfirm()}
                                                    circularProgress={circularProgress}
                                                >
                                                    {t("confirm")}
                                                </CorreosButton>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Container>
                            </>
                        )}
                </>
            }
        </Dialog>
    );
}
